import { computed, ref } from 'vue'

const state = ref({})

export default function (key, options, onTabUpdated, initialTab) {
  const tab = computed(() => state.value[key])

  // can acquire current tab with key
  if (!options && !onTabUpdated) {
    return {
      updateTab,
      tab,
    }
  }

  state.value[key] =
    (tab.value && options.find((o) => o.value === tab.value)?.value) ||
    (initialTab && options.find((o) => o.value == initialTab)?.value) ||
    options?.[0]?.value

  function updateTab(newTab) {
    if (tab.value !== newTab) {
      state.value[key] = newTab
      onTabUpdated && onTabUpdated(newTab)
    }
  }

  return {
    updateTab,
    tab,
  }
}
